import {
  ProcessResponse,
  ProcessExecutionResponse,
  EmailResponse,
  BankAccountResponse,
  EmailTemplateResponse,
  StepResponse,
  StepExecutionResponse,
} from 'api/main/data-contracts';
import { AccountResponse } from 'api/auth/data-contracts';

// Mock Steps for processes
const mockSteps: StepResponse[] = [
  {
    id: 1,
    name: 'Duomenų įvedimas',
    description: 'Įveskite reikalingus duomenis',
    type: 'DATA_INPUT',
    executors: ['USER'],
    notificationType: 'SEND_ON_START',
  },
  {
    id: 2,
    name: 'Apmokėjimas',
    description: 'Atlikite mokėjimą',
    type: 'PAYMENT',
    executors: ['USER'],
    notificationType: 'NONE',
  },
  {
    id: 3,
    name: 'Dokumento pasirašymas',
    description: 'Pasirašykite dokumentą',
    type: 'SIGN',
    executors: ['USER'],
    notificationType: 'SEND_ON_END',
  },
  {
    id: 4,
    name: 'Patvirtinimas',
    description: 'Administratoriaus patvirtinimas',
    type: 'CONFIRMATION',
    executors: ['ADMIN'],
    notificationType: 'SEND_ON_START',
  },
];

// Mock Processes
export const mockProcesses: ProcessResponse[] = [
  {
    id: 1,
    name: 'Vairavimo registracija',
    i18nkey: 'driving_registration',
    active: true,
    version: 3,
    steps: [mockSteps[0], mockSteps[1], mockSteps[2]],
  },
  {
    id: 2,
    name: 'Sutarties pasirašymas',
    i18nkey: 'contract_signing',
    active: true,
    version: 2,
    steps: [mockSteps[0], mockSteps[2], mockSteps[3]],
  },
  {
    id: 3,
    name: 'Mokėjimo patvirtinimas',
    i18nkey: 'payment_confirmation',
    active: true,
    version: 1,
    steps: [mockSteps[1], mockSteps[3]],
  },
  {
    id: 4,
    name: 'Duomenų surinkimas',
    i18nkey: 'data_collection',
    active: false,
    version: 5,
    steps: [mockSteps[0], mockSteps[3]],
  },
  {
    id: 5,
    name: 'Tapatybės patvirtinimas',
    i18nkey: 'identity_verification',
    active: true,
    version: 1,
    steps: [mockSteps[0], mockSteps[2]],
  },
];

// Mock Step Executions
const mockStepExecutions: StepExecutionResponse[] = [
  {
    id: 1,
    status: 'FINISHED',
    name: 'Duomenų įvedimas',
    type: 'DATA_INPUT',
  },
  {
    id: 2,
    status: 'ACTIVE',
    name: 'Apmokėjimas',
    type: 'PAYMENT',
  },
  {
    id: 3,
    status: 'NOT_ACTIVE',
    name: 'Dokumento pasirašymas',
    type: 'SIGN',
  },
];

// Mock Process Executions
export const mockProcessExecutions: ProcessExecutionResponse[] = [
  {
    id: 1,
    status: 'IN_PROGRESS',
    process: mockProcesses[0],
    stepExecutions: mockStepExecutions,
    accountInfoResponse: { email: 'jonas.jonaitis@email.lt', firstName: 'Jonas', lastName: 'Jonaitis' },
    myTurn: true,
  },
  {
    id: 2,
    status: 'IN_PROGRESS',
    process: mockProcesses[1],
    stepExecutions: [
      { id: 4, status: 'FINISHED', name: 'Duomenų įvedimas', type: 'DATA_INPUT' },
      { id: 5, status: 'ACTIVE', name: 'Dokumento pasirašymas', type: 'SIGN' },
    ],
    accountInfoResponse: { email: 'petras.petraitis@email.lt', firstName: 'Petras', lastName: 'Petraitis' },
    myTurn: false,
  },
  {
    id: 3,
    status: 'FINISHED',
    process: mockProcesses[2],
    stepExecutions: [
      { id: 6, status: 'FINISHED', name: 'Apmokėjimas', type: 'PAYMENT' },
      { id: 7, status: 'FINISHED', name: 'Patvirtinimas', type: 'CONFIRMATION' },
    ],
    accountInfoResponse: { email: 'ana.anaite@email.lt', firstName: 'Ana', lastName: 'Anaitė' },
    myTurn: false,
  },
  {
    id: 4,
    status: 'CANCELLED',
    process: mockProcesses[3],
    stepExecutions: [
      { id: 8, status: 'FINISHED', name: 'Duomenų įvedimas', type: 'DATA_INPUT' },
      { id: 9, status: 'NOT_ACTIVE', name: 'Patvirtinimas', type: 'CONFIRMATION' },
    ],
    accountInfoResponse: { email: 'sistema@email.lt', firstName: 'Sistema', lastName: '' },
    myTurn: false,
  },
  {
    id: 5,
    status: 'IN_PROGRESS',
    process: mockProcesses[4],
    stepExecutions: [
      { id: 10, status: 'ACTIVE', name: 'Duomenų įvedimas', type: 'DATA_INPUT' },
      { id: 11, status: 'NOT_ACTIVE', name: 'Dokumento pasirašymas', type: 'SIGN' },
    ],
    accountInfoResponse: { email: 'marius.mariukas@email.lt', firstName: 'Marius', lastName: 'Mariukas' },
    myTurn: true,
  },
];

// Mock Emails
export const mockEmails: EmailResponse[] = [
  {
    id: 1,
    subject: 'Proceso pradžia - Vairavimo registracija',
    body: '<p>Sveiki, jūsų procesas pradėtas.</p>',
    dateSent: '2024-01-15T10:30:00',
    status: 'SUCCEED',
    emailTo: 'jonas.jonaitis@email.lt',
    type: 'PROCESS_START',
  },
  {
    id: 2,
    subject: 'Mokėjimo patvirtinimas',
    body: '<p>Jūsų mokėjimas gautas.</p>',
    dateSent: '2024-01-15T11:45:00',
    status: 'SUCCEED',
    emailTo: 'petras.petraitis@email.lt',
    type: 'PAYMENT_CONFIRMATION',
  },
  {
    id: 3,
    subject: 'Reikalingas veiksmas',
    body: '<p>Prašome prisijungti ir atlikti reikalingą veiksmą.</p>',
    dateSent: '2024-01-15T14:20:00',
    status: 'FAILED',
    emailTo: 'invalid@email',
    type: 'ACTION_REQUIRED',
  },
  {
    id: 4,
    subject: 'Proceso pabaiga',
    body: '<p>Jūsų procesas sėkmingai užbaigtas.</p>',
    dateSent: '2024-01-14T16:00:00',
    status: 'SUCCEED',
    emailTo: 'ana.anaite@email.lt',
    type: 'PROCESS_END',
  },
  {
    id: 5,
    subject: 'Priminimas apie veiksmą',
    body: '<p>Primename, kad turite neužbaigtą veiksmą.</p>',
    dateSent: '2024-01-14T09:00:00',
    status: 'PREPARED',
    emailTo: 'marius.mariukas@email.lt',
    type: 'REMINDER',
  },
];

// Mock Accounts
export const mockAccounts: AccountResponse[] = [
  {
    id: 1,
    email: 'admin@recodinai.lt',
    phone: '+37061234567',
    personCode: '39001011234',
    fullyCreated: true,
    lastLogin: '2024-01-15T08:00:00',
    created: '2023-06-01T10:00:00',
    roles: ['ADMIN', 'USER'],
  },
  {
    id: 2,
    email: 'jonas.jonaitis@email.lt',
    phone: '+37062345678',
    personCode: '38505051234',
    fullyCreated: true,
    lastLogin: '2024-01-15T10:30:00',
    created: '2023-08-15T14:00:00',
    roles: ['USER'],
  },
  {
    id: 3,
    email: 'petras.petraitis@email.lt',
    phone: '+37063456789',
    personCode: '37803031234',
    fullyCreated: true,
    lastLogin: '2024-01-14T16:00:00',
    created: '2023-09-20T09:00:00',
    roles: ['USER'],
  },
  {
    id: 4,
    email: 'ana.anaite@email.lt',
    phone: '+37064567890',
    personCode: '49212121234',
    fullyCreated: true,
    lastLogin: '2024-01-15T11:00:00',
    created: '2023-10-05T11:00:00',
    roles: ['USER'],
  },
  {
    id: 5,
    email: 'marius.mariukas@email.lt',
    phone: '+37065678901',
    personCode: '38901011234',
    fullyCreated: false,
    lastLogin: undefined,
    created: '2024-01-10T15:00:00',
    roles: ['USER'],
  },
];

// Mock Bank Accounts
export const mockBankAccounts: BankAccountResponse[] = [
  {
    id: 1,
    creditorIban: 'LT121000011101001000',
    creditorName: 'UAB RecodinAI',
    currency: 'EUR',
    approved: true,
  },
  {
    id: 2,
    creditorIban: 'LT647044001231465456',
    creditorName: 'UAB Partneris',
    currency: 'EUR',
    approved: true,
  },
  {
    id: 3,
    creditorIban: 'LT327300010123456789',
    creditorName: 'Individual Company',
    currency: 'EUR',
    approved: false,
  },
];

// Mock Email Templates
export const mockEmailTemplates: EmailTemplateResponse[] = [
  {
    id: 1,
    subject: 'Proceso pradžia',
    body: '<p>Sveiki {{name}}, jūsų procesas {{process_name}} pradėtas.</p>',
    type: 'PROCESS_START',
  },
  {
    id: 2,
    subject: 'Reikalingas veiksmas',
    body: '<p>Sveiki {{name}}, prašome prisijungti ir atlikti veiksmą {{action_name}}.</p>',
    type: 'ACTION_REQUIRED',
  },
  {
    id: 3,
    subject: 'Mokėjimo patvirtinimas',
    body: '<p>Sveiki {{name}}, jūsų mokėjimas {{amount}} EUR gautas.</p>',
    type: 'PAYMENT_CONFIRMATION',
  },
  {
    id: 4,
    subject: 'Proceso pabaiga',
    body: '<p>Sveiki {{name}}, jūsų procesas {{process_name}} sėkmingai užbaigtas.</p>',
    type: 'PROCESS_END',
  },
  {
    id: 5,
    subject: 'Priminimas',
    body: '<p>Sveiki {{name}}, primename apie neužbaigtą veiksmą.</p>',
    type: 'REMINDER',
  },
  {
    id: 6,
    subject: 'Dokumentas pasirašytas',
    body: '<p>Sveiki {{name}}, dokumentas sėkmingai pasirašytas.</p>',
    type: 'DOCUMENT_SIGNED',
  },
];

// Dashboard Stats Mock Data
export const mockDashboardStats = {
  activeProcesses: mockProcesses.filter(p => p.active).length,
  executionsToday: 47,
  pendingActions: mockProcessExecutions.filter(e => e.status === 'IN_PROGRESS').length,
  activeUsers: mockAccounts.filter(a => a.fullyCreated).length,
  totalEmails: mockEmails.length,
  successfulEmails: mockEmails.filter(e => e.status === 'SUCCEED').length,
  totalBankAccounts: mockBankAccounts.length,
  approvedBankAccounts: mockBankAccounts.filter(b => b.approved).length,
};

// Analytics data based on mock data
export const mockAnalyticsData = {
  executionsTrend: {
    labels: ['P', 'A', 'T', 'K', 'P', 'Š', 'S'],
    values: [32, 45, 28, 51, 42, 38, 47],
  },
  successRate: {
    successful: Math.round((mockProcessExecutions.filter(e => e.status === 'FINISHED').length / mockProcessExecutions.length) * 100),
    failed: Math.round((mockProcessExecutions.filter(e => e.status === 'CANCELLED').length / mockProcessExecutions.length) * 100),
  },
  topProcesses: {
    labels: mockProcesses.slice(0, 4).map(p => p.name || ''),
    values: [45, 32, 21, 15],
  },
  stepUsage: {
    labels: ['DATA_INPUT', 'PAYMENT', 'SIGN', 'CONFIRMATION', 'NOTIFICATION', 'IDENTIFICATION'],
    values: [89, 67, 61, 52, 48, 34],
  },
};
